import StaffDetails from "./Staffs.json";
import StaffCard from './StaffCard';
import "./OurStaff.scss";

const OurStaff = () => {

    return (
        <section className="staffPageMainParent">
            <header style={{ color: "#116C4A" }}>
                <h2>Our Staff</h2>
                <h3>Department of Tamil</h3>
            </header>
            <article className="staffCardParents">
                {StaffDetails.Staffs.map((staff, index) => (
                    <StaffCard
                        key={index}
                        staffName={staff.staffName}
                        education={staff.education}
                        designation={staff.designation}
                        bgImage={staff.bgImage}
                    />
                ))}
            </article>
        </section>
    )
}

export default OurStaff
